export default __webpack_public_path__ + "static/media/playstore.f902960a.png";